import api from '../api';

export const ZAP_DECK_FETCH_REQUEST = 'ZAP_DECK_FETCH_REQUEST';
export const ZAP_DECK_FETCH_SUCCESS = 'ZAP_DECK_FETCH_SUCCESS';
export const ZAP_DECK_FETCH_FAIL    = 'ZAP_DECK_FETCH_FAIL';

export const ZAP_DECK_UPDATE_REQUEST = 'ZAP_DECK_UPDATE_REQUEST';
export const ZAP_DECK_UPDATE_SUCCESS = 'ZAP_DECK_UPDATE_SUCCESS';
export const ZAP_DECK_UPDATE_FAIL = 'ZAP_DECK_UPDATE_FAIL';

export function fetchZapDeck() {
  return (dispatch, getState) => {
    dispatch(fetchZapDeckRequest());

    api(getState).get('/api/v1/zap_deck').then(response => {
      dispatch(fetchZapDeckSuccess(response.data));
    }).catch(error => {
      dispatch(fetchZapDeckFail(error));
    });
  };
}

export function fetchZapDeckRequest() {
  return {
    type: ZAP_DECK_FETCH_REQUEST,
    skipLoading: true,
  };
}

export function fetchZapDeckSuccess(amounts) {
  return {
    type: ZAP_DECK_FETCH_SUCCESS,
    amounts,
    skipLoading: true,
  };
}

export function fetchZapDeckFail(error) {
  return {
    type: ZAP_DECK_FETCH_FAIL,
    error,
    skipLoading: true,
  };
}

export function updateZapDeck(amounts) {
  return (dispatch, getState) => {
    dispatch(updateZapDeckRequest());

    api(getState).post('/api/v1/zap_deck', { amounts }).then(response => {
      dispatch(updateZapDeckSuccess(response.data));
    }).catch(error => {
      dispatch(updateZapDeckFail(error));
    });
  };
}

export function updateZapDeckRequest() {
  return {
    type: ZAP_DECK_UPDATE_REQUEST,
    skipLoading: true,
  };
}

export function updateZapDeckSuccess(amounts) {
  return {
    type: ZAP_DECK_UPDATE_SUCCESS,
    amounts,
    skipLoading: true,
  };
}

export function updateZapDeckFail(error) {
  return {
    type: ZAP_DECK_UPDATE_FAIL,
    error,
    skipLoading: true,
  };
}
